import { createSlice, createAction } from "@reduxjs/toolkit";
import purge from "store/purge";

const initialState = {
  stripePaymentHistory: [],

  isLoading: false,
};

export default createSlice({
  name: "STRIPE_PAYMENT_HISTORY",
  initialState,
  reducers: {
    fetching: (state) => {
      state.isLoading = true;
    },

    error: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },

    success: (state) => {
      state.isLoading = false;
    },

    setStripePaymentHistory: (state, { payload }) => {
      state.stripePaymentHistory = payload;
    },
  },
  extraReducers: {
    ...purge(initialState),
  },
});

export const FETCH_STRIPE_PAYMENT_HISTORY = createAction(
  "FETCH_STRIPE_PAYMENT_HISTORY"
);
